// @flow

import styled from 'styled-components';

import { SMALL_DEVICE_HEIGHT } from '../../../constants';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-height: ${SMALL_DEVICE_HEIGHT}px) {
    overflow: visible;
  }

  @media (min-height: ${SMALL_DEVICE_HEIGHT + 1}px) {
    margin-top: 40px;
    max-height: ${props => props.deviceHeight * 0.5}px;
    overflow-x: hidden;
  }
`;
